import { useTranslation } from 'react-i18next';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { InputLabel } from '@wajeez-web/components/ui';
import {
  CallbackSelectFormType,
  PredefinedComponentFormType,
  SelectOption,
} from '../Types';
import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import Select, {
  components,
  DropdownIndicatorProps,
  IndicatorSeparatorProps,
} from 'react-select';
import { SelectorIcon } from '@heroicons/react/outline';
import AsyncSelect from 'react-select/async';

export interface FormCallBackSelectInputProps<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields> {
  fieldType: CallbackSelectFormType;
  disabled?: boolean;

  showSelectIndicator?: boolean;
  isMulti?: boolean | undefined;
  prefix?: string;
}

const FormCallBackSelectInput = <TFormFields extends FieldValues>({
  fieldType,
  disabled,
  ...props
}: FormCallBackSelectInputProps<TFormFields>) => {
  const { field, fieldState } = useController({
    ...props,
    rules: {
      required: fieldType.required ? 'Required' : undefined,
      ...props.rules,
    },
  });

  const { dir } = useCommonSelector((state) => state.common.settings);

  const { t } = useTranslation();

  const isError = fieldState.error && fieldState.isTouched;

  // TODO: Implemnt This
  return (
    <>
      {fieldType.label && (
        <InputLabel
          text={
            t(
              `inputs.labels.${fieldType.label}`,
              fieldType.label.toString() || ''
            ) as string
          }
          name={field.name}
          required={fieldType.required}
        />
      )}
      {/* <AsyncSelect
        defaultOptions={defaultOptions}
        cacheOptions
        inputValue={inputValue}
        isSearchable={true}
        className="input"
        loadOptions={debouncedSearchValue}
        onInputChange={(val) =>
          debouncedSearchValue && debouncedSearchValue(val)
        }
        menuIsOpen={undefined}
        isMulti={isMulti || undefined}
        placeholder={t(
          `inputs.placeholders.${placeholder}`,
          placeholder || ''
        )?.toString()}
        name={name}
        onChange={handleChange}
        value={value}
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: '36px !important',
            padding: '0px !important',
            textAlign: dir === 'ltr' ? 'left' : 'right',
            ' --tw-ring-opacity': 1,
            '--tw-ring-opacity': state.isFocused ? 0.1 : 'default',
            ' --tw-ring-color': state.isFocused
              ? 'var(--theme-ring-color)'
              : 'default',
            '--tw-ring-offset-shadow': state.isFocused
              ? 'var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)'
              : 'default',
            '--tw-ring-shadow': state.isFocused
              ? 'var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)'
              : 'default',
            boxShadow: state.isFocused
              ? ' var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)'
              : 'default',
          }),
          menu: (provided) => ({
            ...provided,
            position: 'absolute',
            textAlign: dir === 'ltr' ? 'left' : 'right',
            'z-index': '99999 !important',
          }),
          container: (base) => ({
            ...base,
            fontSize: '14px !important',
            padding: '0px !important',
          }),
        }}
        theme={(theme) => ({
          ...theme,
          zIndex: 999,
          border: '0px none',
          width: '100%',
          borderRadius: 6,
          padding: 0,
          margin: 0,
          colors: {
            ...theme.colors,

            primary: 'var(--theme-primary)',
          },
        })}
        components={{ DropdownIndicator, IndicatorSeparator }}
      /> */}
    </>
  );
};

const DropdownIndicator = (
  props: DropdownIndicatorProps<SelectOption, true>
) => {
  return (
    <components.DropdownIndicator {...props}>
      <SelectorIcon className="h-5 w-5 text-gray-400" />
    </components.DropdownIndicator>
  );
};

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  backgroundColor: 'white',
  marginBottom: 8,
  marginTop: 8,
  width: 1,
};

const IndicatorSeparator = ({
  innerProps,
}: IndicatorSeparatorProps<SelectOption, true>) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

export default FormCallBackSelectInput;
